import { TableColumnHeaderProps } from "@chakra-ui/react"

// Шапка таблиц проверки и истории проверок: обычный регистр (капс с разрядкой
// растягивал колонки), остаётся вверху экрана при прокрутке, полупрозрачная
// с размытием — как полоса с кнопками внизу страницы проверки
export const stickyHeaderCellProps: TableColumnHeaderProps = {
  textTransform: "none",
  // Выше обычной: заголовки отделены от строк, а не прижаты к ним
  py: 4,
  letterSpacing: "normal",
  fontSize: "xs",
  color: "gray.600",
  position: "sticky",
  // Минус отступ страницы (Page, py=5): липкий элемент встаёт у внутреннего
  // отступа прокрутки, и над шапкой просвечивали строки. Ещё 2px: у таблицы
  // схлопнутые границы, и на ретине между краем и шапкой оставалась щель
  top: "calc(var(--chakra-space-5) * -1 - 2px)",
  zIndex: 1,
  bg: "whiteAlpha.600",
  backdropFilter: "blur(6px)",
  boxShadow: "inset 0 -1px 0 var(--chakra-colors-gray-200)",
}
